import { render, staticRenderFns } from "./CalendarCup.vue?vue&type=template&id=5402a53e&"
import script from "./CalendarCup.vue?vue&type=script&lang=js&"
export * from "./CalendarCup.vue?vue&type=script&lang=js&"
import style0 from "./CalendarCup.vue?vue&type=style&index=0&id=5402a53e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports